import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${API_BASE}/api`;

export const BOOKING_URL =
  "https://reservation.asiwebres.com/v5/RoomAvailability.aspx?id=9fd4019148be43da81631afff24d44e8";

export const NAP = {
  name: "Westbridge Inn & Suites",
  addressLine1: "106 S Baird St",
  city: "Clinton",
  state: "MO",
  postal: "64735",
  phone: "(660) 885-2206",
  phoneTel: "+16608852206",
  email: "info@westbridgeinnandsuites.com",
  checkIn: "3:00 PM",
  checkOut: "11:00 AM",
  slogan: "Great service. Clean rooms.",
};

export const client = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});
